import React, { useEffect, useState, Text } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory,
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from 'react-router-dom';
import { setCidade, getIdCidadeEcrie, getTotem } from '../../api/apiFactory';
import {
  fetchCidades, fetchLimparCookie, fetchNomeCidade, fetchSecretarias, fetchNocicias,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalAjuda, abrirModalLoginManifestacao, abrirModalServico, resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import FormularioManifestacao from '../../components/FormularioManifestacao/FormularioManifestacao';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import { ReactComponent as AdicionarSvg } from '../../assets/icons/adicionar.svg';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  Alerta, AppBody, AppFragment, CampoForm,
  Container, Divisor, Grid, GridNoticias, Linha, Titulo,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import ModalServico from '../../components/ModalServico/ModalServico';
import ListaNoticia from '../../components/ListaNoticia/ListaNoticia';

const defaulValues = {
  BuscaCidade: '',
  IdEstado: '',
  NomeEstado: '',
};

const SelecionarNoticias = () => {
  const [listaEstados, setListaEstados] = useState(null);
  const [listaCidades, setListaCidades] = useState(null);
  const [estadoSelecionado, setEstadoSelecionado] = useState(false);
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [noticias, setNoticias] = useState([]);
  const [values, setValues] = useState(defaulValues);
  const history = useHistory();

  const [pesquisa, setPesquisa] = useState('');
  const [texto, setTexto] = useState('');

  const dispatch = useDispatch();

  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);

  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosModal = useSelector(selectModal);

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  window.onload = () => {
    dispatch(resetarModais());
  };

  const escolherCidade = async (Id, Campo, Brasao) => {
    setListaSecretarias(null);
    setCidade({ Id, Campo });
    setEstadoSelecionado(false);
    setValues(defaulValues);
    dispatch(definirCidade({
      idCidade: Id,
      nomeCidade: Campo,
      brasaoCidade: Brasao,
    }));
    await fetchLimparCookie();
    await dispatch(fetchConfiguracoesCidade());
    await fetchSecretarias().then(setListaSecretarias);
  };

  useEffect(() => {
    fetchCidades().then(setListaEstados);
    if (cookieId) {
      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => { escolherCidade(cookieId, nomeCidade); });
    }

    if (dadosCidade.data) {
      fetchSecretarias().then(setListaSecretarias);
    }

    fetchNocicias().then((response) => setNoticias(response));

    if (!(getIdCidadeEcrie() > 0)) {
      history.push('/');
    }
  }, []);

  useEffect(() => {
    setValues({
      ...values,
      BuscaCidade: pesquisa,
    });
  }, [pesquisa]);

  if (!listaEstados) {
    return (
      <Carregar />
    );
  }

  if (dadosCidade.data && !listaSecretarias) {
    return (
      <Carregar />
    );
  }

  if (dadosCidade.data && dadosSecretaria.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalServico === 'aberto' && (<ModalServico />)}
        <AppHeader />
        <AppBody desfoque={dadosModal.desfoque} className="controle-fundo">
          <FormularioManifestacao />
        </AppBody>
      </AppFragment>
    );
  }

  if (dadosCidade.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda />)}
        {dadosModal.modalServico === 'aberto' && (<ModalServico />)}
        <AppHeader />
        <Botao
          onClick={() => dispatch(abrirModalServico())}
          ajuda
        />
        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
          <Container totem={getTotem() === 'true'}>
            <Titulo totem={getTotem() === 'true'}>
              Notícias -
              {' '}
              {dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade}
            </Titulo>
            <Botao
              link
              label="Voltar"
              style={{ marginRight: espacamento.pequeno, display: 'block', marginBottom: espacamento.extraGrande }}
              onClick={() => history.push('/servicos')}
            />
            <GridNoticias>
              {noticias.length > 0 && noticias.map((item) => (
                <Link style={{ textDecoration: 'none', color: 'black' }} to={`/noticia/${item.Id}`}>
                  <ListaNoticia
                    fotoCapaThumb={item.FotoCapaThumb}
                    titulo={item.Titulo}
                    dataHora={item.DataHora}
                    descricao={item.Descricao}
                  />
                </Link>
              ))}
            </GridNoticias>
            {(noticias.Message === 'Nenhum registro foi encontrado.' || noticias.Message === 'Nenhuma cidade foi selecionada.') ? 'Nenhuma notícia encontrada.' : ''}
          </Container>
        </AppBody>
      </AppFragment>
    );
  }
  return true;
};

export default SelecionarNoticias;
